import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
import BranchName from 'automation-ui-canvas/components/canvas/BranchName';
import { formatNumberForEnrollmentConversionReporting, formatPercentageForEnrollmentConversionReporting } from 'automation-ui-canvas/containers/enrollment-conversion/enrollmentConversionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentConversionPanelBranchRow = ({
  action,
  index,
  edgeId,
  flow,
  handleGetActionOutputsForTargetActionById,
  isReportingEnabled,
  enrollmentConversionData
}) => {
  var _conversionReport$sou, _actionBranchPrevActi, _actionBranchPrevActi2;
  const conversionReport = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport;
  const prevActionId = getPreviousActionId(edgeId);
  const nextActionId = action.getNextActionIdByEdgeId(edgeId);
  const actionBranchPrevActionIdObj = conversionReport === null || conversionReport === void 0 || (_conversionReport$sou = conversionReport.sourceDestinationMap) === null || _conversionReport$sou === void 0 ? void 0 : _conversionReport$sou[prevActionId];
  const branchTotal = actionBranchPrevActionIdObj ? Object.values(actionBranchPrevActionIdObj).reduce((prev, next) => prev + next, 0) : 0;
  const actionBranchCount = nextActionId ? (_actionBranchPrevActi = actionBranchPrevActionIdObj === null || actionBranchPrevActionIdObj === void 0 ? void 0 : actionBranchPrevActionIdObj[nextActionId]) !== null && _actionBranchPrevActi !== void 0 ? _actionBranchPrevActi : 0 : (_actionBranchPrevActi2 = actionBranchPrevActionIdObj === null || actionBranchPrevActionIdObj === void 0 ? void 0 : actionBranchPrevActionIdObj[`end-${index}`]) !== null && _actionBranchPrevActi2 !== void 0 ? _actionBranchPrevActi2 : 0;
  const percentage = branchTotal !== 0 ? actionBranchCount / branchTotal * 100 : 0;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation.enrollmentConversion.panel.tooltips.branch",
      options: {
        value: formatNumberForEnrollmentConversionReporting(actionBranchCount),
        total: formatNumberForEnrollmentConversionReporting(branchTotal)
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentConversion.panel.branchTable.defaultState.tooltip"
    }),
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: /*#__PURE__*/_jsx(BranchName, {
            flow: flow,
            edgeId: edgeId,
            handleGetActionOutputsForTargetActionById: handleGetActionOutputsForTargetActionById
          })
        })
      }), /*#__PURE__*/_jsx("td", {
        className: "text-right",
        children: isReportingEnabled ? formatPercentageForEnrollmentConversionReporting(percentage) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.panel.branchTable.defaultState.continued"
        })
      })]
    })
  });
};
export default EnrollmentConversionPanelBranchRow;